"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISCNSigningClient = exports.formatISCNPayload = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
// eslint-disable-next-line import/no-extraneous-dependencies
const proto_signing_1 = require("@cosmjs/proto-signing");
const stargate_1 = require("@cosmjs/stargate");
const tx_1 = require("@likecoin/iscn-message-types/dist/iscn/tx");
const tx_2 = require("cosmjs-types/cosmos/tx/v1beta1/tx");
const fast_json_stable_stringify_1 = __importDefault(require("fast-json-stable-stringify"));
const constant_1 = require("./constant");
const queryClient_1 = require("./queryClient");
const registry = new proto_signing_1.Registry([
    ...stargate_1.defaultRegistryTypes,
    ['/likechain.iscn.MsgCreateIscnRecord', tx_1.MsgCreateIscnRecord],
    ['/likechain.iscn.MsgUpdateIscnRecord', tx_1.MsgUpdateIscnRecord],
    ['/likechain.iscn.MsgChangeIscnRecordOwnership', tx_1.MsgChangeIscnRecordOwnership],
]);
function formatISCNPayload(payload, version = 1) {
    if (!payload)
        throw new Error('INVALID_ISCN_PAYLOAD');
    const { name, description, keywords = [], url, contentFingerprints, stakeholders: inputStakeHolders = [], type, usageInfo, recordNotes } = payload, data = __rest(payload, ["name", "description", "keywords", "url", "contentFingerprints", "stakeholders", "type", "usageInfo", "recordNotes"]);
    const stakeholders = inputStakeHolders.map((s) => Buffer.from(JSON.stringify(s), 'utf8'));
    const contentMetadata = Object.assign({ '@context': 'http://schema.org/', '@type': type, name,
        description,
        version,
        url, keywords: keywords.join(','), usageInfo }, data);
    return {
        recordNotes,
        contentFingerprints,
        stakeholders,
        contentMetadata: Buffer.from(JSON.stringify(contentMetadata), 'utf8'),
    };
}
exports.formatISCNPayload = formatISCNPayload;
class ISCNSigningClient {
    constructor() {
        this.signingClient = null;
        this.rpcURL = constant_1.DEFAULT_RPC_ENDPOINT;
        this.denom = constant_1.COSMOS_DENOM;
        this.queryClient = new queryClient_1.ISCNQueryClient();
    }
    getSigningStargateClient() {
        return this.signingClient;
    }
    getISCNQueryClient() {
        return this.queryClient;
    }
    async connect(rpcURL) {
        await this.queryClient.connect(rpcURL);
        this.rpcURL = rpcURL;
        await this.fetchISCNFeeDenom();
    }
    async setSigner(signer) {
        this.signingClient = await stargate_1.SigningStargateClient.connectWithSigner(this.rpcURL, signer, { registry });
    }
    async connectWithSigner(rpcURL, signer) {
        await this.connect(rpcURL);
        await this.setSigner(signer);
    }
    async fetchISCNFeeDenom() {
        const feePerByte = await this.queryClient.queryFeePerByte();
        if (feePerByte === null || feePerByte === void 0 ? void 0 : feePerByte.denom)
            this.denom = feePerByte.denom;
    }
    async esimateISCNTxGasAndFee(payload, { gasPrice } = {}) {
        const [gas, iscnFee] = await Promise.all([
            this.estimateISCNTxGas(payload, { gasPrice }),
            this.estimateISCNTxFee(payload),
        ]);
        return {
            gas,
            iscnFee,
        };
    }
    async estimateISCNTxFee(payload, { version = 1 } = {}) {
        const record = formatISCNPayload(payload);
        const feePerByte = await this.queryClient.queryFeePerByte();
        const feePerByteAmount = feePerByte ? parseInt(feePerByte.amount, 10) : 1;
        const { recordNotes, contentFingerprints, stakeholders, contentMetadata, } = record;
        const now = new Date();
        const obj = {
            '@context': {
                '@vocab': 'http://iscn.io/',
                recordParentIPLD: {
                    '@container': '@index',
                },
                stakeholders: {
                    '@context': {
                        '@vocab': 'http://schema.org/',
                        entity: 'http://iscn.io/entity',
                        rewardProportion: 'http://iscn.io/rewardProportion',
                        contributionType: 'http://iscn.io/contributionType',
                        footprint: 'http://iscn.io/footprint',
                    },
                },
                contentMetadata: {
                    '@context': null,
                },
            },
            '@type': 'Record',
            '@id': `iscn://${constant_1.ISCN_REGISTRY_NAME}/btC7CJvMm4WLj9Tau9LAPTfGK7sfymTJW7ORcFdruCU/1`,
            recordTimestamp: now.toISOString(),
            recordVersion: version,
            recordNotes,
            contentFingerprints,
            recordParentIPLD: {},
        };
        if (version > 1) {
            obj.recordParentIPLD = {
                '/': 'bahuaierav3bfvm4ytx7gvn4yqeu4piiocuvtvdpyyb5f6moxniwemae4tjyq',
            };
        }
        const byteSize = Buffer.from((0, fast_json_stable_stringify_1.default)(obj), 'utf-8').length
            + Buffer.from((0, fast_json_stable_stringify_1.default)({ stakeholders: [], contentMetadata: {} }), 'utf-8').length
            + stakeholders.reduce((acc, s) => acc + s.length, 0)
            + stakeholders.length
            + contentMetadata.length;
        const feeAmount = new bignumber_js_1.default(byteSize).multipliedBy(feePerByteAmount);
        return {
            amount: feeAmount.toFixed(0, 0),
            denom: (feePerByte === null || feePerByte === void 0 ? void 0 : feePerByte.denom) || this.denom,
        };
    }
    async estimateISCNTxGas(payload, { denom = this.denom, gasPrice = constant_1.DEFAULT_GAS_PRICE_NUMBER, } = {}) {
        const record = await formatISCNPayload(payload);
        const msg = {
            type: 'likecoin-chain/MsgCreateIscnRecord',
            value: {
                from: constant_1.STUB_WALLET,
                record,
            },
        };
        const value = {
            msg: [msg],
            fee: {
                amount: [{
                        denom: this.denom,
                        amount: '200000', // temp number here for estimation
                    }],
                gas: '200000', // temp number here for estimation
            },
        };
        const obj = {
            type: 'cosmos-sdk/StdTx',
            value,
        };
        const txBytes = Buffer.from((0, fast_json_stable_stringify_1.default)(obj), 'utf-8');
        const byteSize = new bignumber_js_1.default(txBytes.length);
        const gasUsedEstimationBeforeBuffer = byteSize
            .multipliedBy(constant_1.GAS_ESTIMATOR_SLOPE)
            .plus(constant_1.GAS_ESTIMATOR_INTERCEPT);
        const buffer = gasUsedEstimationBeforeBuffer.multipliedBy(constant_1.GAS_ESTIMATOR_BUFFER_RATIO);
        const gasUsedEstimation = gasUsedEstimationBeforeBuffer.plus(buffer);
        const gas = gasUsedEstimation.toFixed(0, 0);
        return {
            fee: {
                amount: [{
                        amount: new bignumber_js_1.default(gas)
                            .multipliedBy(gasPrice || constant_1.DEFAULT_GAS_PRICE_NUMBER).toFixed(0, 0),
                        denom,
                    }],
                gas,
            },
        };
    }
    async signOrBroadcast(senderAddress, message, fee, { memo = '', broadcast = true, accountNumber, sequence, chainId, } = {}) {
        const client = this.signingClient;
        if (!client)
            throw new Error('SIGNING_CLIENT_NOT_CONNECTED');
        let signData;
        if ((accountNumber !== undefined || sequence !== undefined || chainId !== undefined)) {
            if (!(accountNumber !== undefined && sequence !== undefined && chainId !== undefined)) {
                throw new Error('MUST_DEFINE_ALL_SIGNING_PARAM');
            }
            signData = {
                accountNumber,
                sequence,
                chainId,
            };
        }
        const txRaw = await client.sign(senderAddress, [message], fee, memo, signData);
        if (!broadcast) {
            return txRaw;
        }
        const txBytes = tx_2.TxRaw.encode(txRaw).finish();
        const response = await client.broadcastTx(txBytes);
        (0, stargate_1.assertIsBroadcastTxSuccess)(response);
        return response;
    }
    async createISCNRecord(senderAddress, payload, _a = {}) {
        var { fee: inputFee, gasPrice } = _a, signOptions = __rest(_a, ["fee", "gasPrice"]);
        const client = this.signingClient;
        if (!client)
            throw new Error('SIGNING_CLIENT_NOT_CONNECTED');
        const record = formatISCNPayload(payload);
        const message = {
            typeUrl: '/likechain.iscn.MsgCreateIscnRecord',
            value: {
                from: senderAddress,
                record,
            },
        };
        let fee = inputFee;
        if (!fee) {
            ({ fee } = await this.estimateISCNTxGas(payload, { gasPrice }));
        }
        else if (gasPrice) {
            throw new Error('CANNOT_SET_BOTH_FEE_AND_GASPRICE');
        }
        const response = await this.signOrBroadcast(senderAddress, message, fee, signOptions);
        return response;
    }
    async updateISCNRecord(senderAddress, iscnId, payload, _a = {}) {
        var { fee: inputFee, gasPrice } = _a, signOptions = __rest(_a, ["fee", "gasPrice"]);
        const client = this.signingClient;
        if (!client)
            throw new Error('SIGNING_CLIENT_NOT_CONNECTED');
        const record = formatISCNPayload(payload);
        const message = {
            typeUrl: '/likechain.iscn.MsgUpdateIscnRecord',
            value: {
                from: senderAddress,
                iscnId,
                record,
            },
        };
        let fee = inputFee;
        if (!fee) {
            ({ fee } = await this.estimateISCNTxGas(payload, { gasPrice }));
        }
        else if (gasPrice) {
            throw new Error('CANNOT_SET_BOTH_FEE_AND_GASPRICE');
        }
        const response = await this.signOrBroadcast(senderAddress, message, fee, signOptions);
        return response;
    }
    async changeISCNOwnership(senderAddress, newOwnerAddress, iscnId, _a = {}) {
        var { fee: inputFee, gasPrice } = _a, signOptions = __rest(_a, ["fee", "gasPrice"]);
        const client = this.signingClient;
        if (!client)
            throw new Error('SIGNING_CLIENT_NOT_CONNECTED');
        const message = {
            typeUrl: '/likechain.iscn.MsgChangeIscnRecordOwnership',
            value: {
                from: senderAddress,
                iscnId,
                newOwner: newOwnerAddress,
            },
        };
        let fee = inputFee;
        if (!fee) {
            fee = {
                amount: [{
                        amount: new bignumber_js_1.default(constant_1.ISCN_CHANGE_OWNER_GAS)
                            .multipliedBy(gasPrice || constant_1.DEFAULT_GAS_PRICE_NUMBER).toFixed(0, 0),
                        denom: this.denom,
                    }],
                gas: constant_1.ISCN_CHANGE_OWNER_GAS.toString(),
            };
        }
        else if (gasPrice)
            throw new Error('CANNOT_SET_BOTH_FEE_AND_GASPRICE');
        const response = await this.signOrBroadcast(senderAddress, message, fee, signOptions);
        return response;
    }
}
exports.ISCNSigningClient = ISCNSigningClient;
//# sourceMappingURL=signingClient.js.map